import { useEffect, useState, useContext } from 'react';
import { downloadTradesListReport, fetchTradesListReports } from 'services/complianceReportsServices';
import AuthContext from "contexte/AuthContext"
import { useTranslation } from 'react-i18next';
import DashboardLayout from 'components/layout/dashboard/DashboardLayout'
import Notification from 'components/notifications/Notification';
import { launchError } from 'components/notifications';
import DownloaderLink from 'components/DownloaderLink/DownloaderLink';
import './tradesList.css'

const TradesList = () => {

  const { user } = useContext(AuthContext);
  const { t } = useTranslation();
  const [files, setFiles] = useState([]);

  useEffect(() => {
    const fetchReportList = async () => {
      try {
        const data = await fetchTradesListReports(user);
        setFiles(data);
      } catch (error) {
        launchError(t('notifications.reports.compliance.list.error'))
      }
    }

    fetchReportList();
  }, [])

  return (
    <DashboardLayout page={t(`pages_name.report_compliance_trades_list`)}>
      <Notification />
      <div className='trades_list_title_component'>
        <h2>{t(`pages.trades_list.title`)}</h2>
      </div>
      <div>
        <ul>
          {files.map(file => (
            <DownloaderLink
              filename={`trades_list_${file}.xlsx`}
              fetchData={downloadTradesListReport}
              fetchDataParams={{ user, fileName: file }}
              type={'excel'}
              display={file}
              key={file}
            />
          ))}
        </ul>
      </div>
    </DashboardLayout>
  )
}

export default TradesList;